(() => {
  function closeMenus(except) {
    document.querySelectorAll('.ocean-nav details[open]').forEach(menu => {if(menu !== except) menu.open = false;});
  }
  document.addEventListener('click', event => {
    const summary = event.target.closest('.ocean-nav summary');
    if (summary) {
      event.preventDefault();
      const menu = summary.parentElement;
      const shouldOpen = !menu.open;
      closeMenus(menu);
      menu.open = shouldOpen;
    } else if (!event.target.closest('.ocean-nav details')) closeMenus();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      const menu = event.target.closest('.ocean-nav details[open]');
      closeMenus();
      if (menu) menu.querySelector('summary')?.focus();
    }
  });
})();
